import type { SVGProps } from "react";
const SvgSidebarLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeWidth={1.25}
      d="M1.667 10c0-3.074 0-4.611.678-5.701.25-.403.562-.754.92-1.036.97-.763 2.336-.763 5.068-.763h3.334c2.732 0 4.099 0 5.067.763.359.282.67.633.921 1.036.678 1.09.678 2.627.678 5.701s0 4.611-.678 5.701c-.25.403-.562.754-.92 1.036-.97.763-2.336.763-5.068.763H8.333c-2.732 0-4.099 0-5.067-.763a4 4 0 0 1-.921-1.036c-.678-1.09-.678-2.627-.678-5.701Z"
    />
    <path
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth={1.25}
      d="M7.917 2.5v15"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.25}
      d="M4.167 5.833H5m-.833 2.5H5"
    />
  </svg>
);
export default SvgSidebarLeft;
